import { useIsMobile } from "@/hooks/useIsMobile";
import EmblaSlider from "../../lib/Embla-slider";
import { TSlideWidith } from "../../lib/Embla-slider/EmblaSliderContainer";
import { JSX } from "react";

type TProps = {
  children: React.ReactElement[];
};

const GallerySlider: React.FC<TProps> = ({ children }) => {
  const isMobile = useIsMobile();
  const imgWidth = isMobile ? 346.67 : 480;
  const width = imgWidth + 32;

  return (
    <EmblaSlider>
      <EmblaSlider.EmblaSliderViewport>
        <EmblaSlider.EmblaSliderContainer
          gap={32}
          slides={[
            ...(children as Array<JSX.Element>)?.map((child) => ({
              component: <div style={{ width: width }}>{child}</div>,
              width: "auto" as TSlideWidith,
            })),
          ]}
        />
        <EmblaSlider.EmblaFilters />
        <EmblaSlider.EmblaSliderPrevNextButtons />
      </EmblaSlider.EmblaSliderViewport>
    </EmblaSlider>
  );
};

export default GallerySlider;
